import { Container, Service } from 'typedi';

import { IntlStore } from '../stores/IntlStore';
import { listenToParentLocale } from '../utils/embedding';
import { asLocale, rememberLocale, sessionLocale } from '../utils/locale';

@Service()
export class LocaleController {
  private readonly _intlStore = Container.get(IntlStore);

  /** The language of this page load. */
  init = (): void => this._intlStore.setLocale(sessionLocale(window.location.search, navigator.language));

  /** UA2 keeps the frame and sends its new language, so switching it does not reload the app and its data. */
  followParent = (): (() => void) =>
    listenToParentLocale(tag => {
      const next = asLocale(tag);
      if (!next) return;
      rememberLocale(next);
      this._intlStore.setLocale(next);
    });
}
